import {Fragment} from "react";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import ComponentConfig from "../../ComponentConfig";
import EmailTemplateList from "../../../editors/lists/EmailTemplateList";
import {loadComponent} from "../../../../utils/components";
import Button from "../../Button";
import React, {useState} from "react";

export const EmailTemplateButton = (props) => {
    const [template, setTemplate] = useState(null);
    const [opened, setOpened] = useState(false);
    return <Fragment>
        <Button
            color="default"
            onClick={() => {
                setTemplate(null);
                setOpened(true);
            }}
            icon="dashboard"
            tooltip="Template betöltés"
            disabled={props.disabled || props.isLoading}
        />
        {(!!opened || !!template) && <Portal>
            <Modal
                state="on"
                size="large"
                header="Sablonok"
                disabled={props.disabled || props.isLoading}
                buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default", disabled: props.disabled || props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            try {
                                setOpened(false);
                            } catch (e) {

                            }
                        }
                    }
                ]}
            >
                <ComponentConfig componentName="EmailTemplate">
                    <EmailTemplateList
                        loadForm={(template) => {
                            setTemplate(template);
                            setOpened(false);
                        }}
                    />
                </ComponentConfig>
            </Modal>
            {template && <Modal
                state="on"
                size="small"
                header="Biztos betöltöd?"
                disabled={props.disabled || props.isLoading}
                buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default", disabled: props.disabled || props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            setTemplate(null);
                        }
                    },{
                        text: "Igen",
                        props: {color: "warning", disabled: props.disabled || props.isLoading},
                        onClick: async () => {
                            loadComponent("EmailTemplate", template, ["template","template_engine","replacement_engine","sender_email","sender_name"]).then((data) => {
                                props.saveTemplate && props.saveTemplate(data.template);
                                props.saveTemplateEngine && props.saveTemplateEngine(data.template_engine);
                                props.saveReplacementEngine && props.saveReplacementEngine(data.replacement_engine);
                                props.saveSenderEmail && props.saveSenderEmail(data.sender_email);
                                props.saveSenderName && props.saveSenderName(data.sender_name);
                                setTemplate(null);
                            });
                        }
                    }
                ]}
            >
                Ha betöltöd ezt a sablont, minden eddigi módosításod elvész!
            </Modal>}
        </Portal>}
    </Fragment>
}